import { render, staticRenderFns } from "./NumericCell.vue?vue&type=template&id=bdf6c44c&"
import script from "./NumericCell.vue?vue&type=script&lang=ts&"
export * from "./NumericCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports